import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "./CommonHeader";

export const IsAuthValid = createAsyncThunk("IsAuthValid", async () => {
  try {
    const { data } = await axios.post(
      process.env.REACT_APP_BackEndIP+"/IsLogin",
      {},
      {
        headers: myHeaders(),
      }
    );
    return data;
  } catch (error) {
    console.error("!!!", error);
    localStorage.clear();
    window.location.assign("/");
  }
});
